import { fg } from '@confluence/feature-gating';

export const isMeetingRecorderEligibilityEnabled = (): boolean =>
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	fg('twcg-2202-loom-meeting-nudge-ht-gate') || fg('twcg-2202-loom-meeting-nudge-lt-gate');
